import { useEffect, useState } from "react";
import { capitalizeFirstChar } from "../components/util/stringUtils";

export interface UserAgentData {
  platform?: string;
  platformVersion?: string;
}

interface NavigatorUAData {
  getHighEntropyValues(hints: string[]): Promise<UserAgentData>;
}

type ExtendedNavigator = Navigator & {
  userAgentData?: NavigatorUAData;
};

const DETECT_LIST = ["android", "iphone", "ipad", "mac", "windows", "linux"];

export const useUserAgentData = () => {
  const [userAgentData, setUserAgentData] = useState<UserAgentData>();

  useEffect(() => {
    const getDataByUserAgentStr = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      let os =
        DETECT_LIST.find((name) => userAgent.includes(name)) ?? "unknown";

      switch (os) {
        case "iphone":
        case "ipad":
          os = "iOS";
          break;
        case "mac":
          os = "MacOS";
          break;
        default:
          os = capitalizeFirstChar(os);
      }

      setUserAgentData({
        platform: os,
        platformVersion: "",
      });
    };

    // modern way
    const fetchUserAgentData = async () => {
      const uaData = (navigator as ExtendedNavigator).userAgentData;
      let data: UserAgentData = {
        platform: "",
        platformVersion: "",
      };

      if (uaData && typeof uaData.getHighEntropyValues === "function") {
        try {
          data = await uaData.getHighEntropyValues(["platformVersion"]);
          if (data.platform !== "") setUserAgentData(data);
        } catch (error) {
          console.error("Error fetching User-Agent Data:", error);
        } finally {
          if (data.platform === "") {
            getDataByUserAgentStr();
          }
        }
      } else {
        // fallback case
        getDataByUserAgentStr();
      }
    };

    fetchUserAgentData();
  }, []);

  return { userAgentData };
};
